var Curriculog = Curriculog || {};
Curriculog.ProposalForm = Curriculog.ProposalForm || {};

Curriculog.ProposalForm.RadioField = (function ($, _, Backbone, RadioField) {

	RadioField = Curriculog.ProposalForm.Field.extend({
		modelClass: Curriculog.ProposalForm.RadioFieldModel,

		/**
		 * Used to return the value of the field
		 *
		 * @returns {String} - Numeric index of the value selected or '' if
		 *                     nothing is selected.
		 */
		getValue: function() {
			var mode = this.mode,
				$fields = this.getInput(),
				value = '';

			if (mode == 'edit') {
				value = $fields.filter(':checked').val();
			} else {
				value = $fields.filter('[data-selected="1"]').data('option');
			}

			if (value === undefined) {
				return '';
			}

			return String(value);
		},

		/**
		 * Triggers a change:programType event after save if this is the program
		 * type field.
		 *
		 * @returns {promise}
		 */
		afterSave: function() {
			if (this.model.get('systemRequired') == 'programType') {
				var isSharedCore = +this.model.get('value');
				Backbone.trigger('change:programType', isSharedCore);
			}
			return Curriculog.ProposalForm.Field.prototype.afterSave.apply(this, arguments);
		},

		/**
		 * MASSIVE TERRIBLE SHORTCUT HACK to disable the conflict dialog
		 *
		 */
		showConflict: function(data) {
			return false;
			// Oh writing this feels nasty. TP: 9214
		}

	});

	return RadioField;

})($, _, Backbone, Curriculog.ProposalForm.RadioField || {});